<template>
    <span class="badge badge-pill" :class="{'badge-success': count > 0, 'badge-secondary': count === 0, }">
        {{ count }}
    </span>
</template>

<script>
    const axios = require('axios');

    export default {
        props: {
            'initialCount': String,
            'updateRoute': String
        },

        data() {
            return {
                count: 0,
            }
        },

        methods: {

            update() {
                axios.get(this.updateRoute)
                    .then(response => {
                        this.count = response.data.count;
                    });
            }

        },

        mounted() {
            this.count = parseInt(this.initialCount);
        }
    };
</script>